export function buyerAdvisoryResidentialKWSW() {
return [   // Release 2026-01-09 09:39:06
 
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 166.6,
   left: 166.8,
   width: 383.88,
   height: 16.287
}
,
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.6,
   left: 166.68,
   width: 378.12,
   height: 16.287
}
,
{
   page: 7,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 605.8,
   left: 53.4,
   width: 171.12,
   height: 14.869
}
,
{
   page: 7,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 602.985,
   left: 226.56,
   width: 76.046,
   height: 18.128
}
] }
